import { IElement } from "core/types";

export function buildSelectors(element: IElement) {
  const index = () => element.props.index;

  return {
    index,
  };
}
